import { render, staticRenderFns } from "./TgHomeSales.vue?vue&type=template&id=0c1fd810&"
import script from "./TgHomeSales.vue?vue&type=script&lang=js&"
export * from "./TgHomeSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports